<script>
import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";

export default {
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<template>
  <v-app>
    <AppHeader />
    <router-view />
    <AppFooter />
  </v-app>
</template>

<style>
html,
body,
#app {
  overflow-x: hidden;
}
</style>
